import { computed, observable } from 'mobx';
import type { Moment } from '@this/src/lib/moment';
import moment from 'moment';
import type { FlightSegmentResponseArgs } from './flight_segment2';
import FlightSegment, { convertFlightSegmentResponseToArgs } from './flight_segment2';

export type FlightSliceResponseArgs = {
  id: string;
  segments: FlightSegmentResponseArgs[];
  duration_raw: number;
  duration: string;
  deadline: string | null;
  time_to_live: number | null;
  raw_ticket_expired_at: string | null;
  ticketing_enable: boolean;
  routes: string[];
  description: string;
};

export type FlightSliceArgs = {
  id: string;
  duration: string;
  deadline?: Moment;
  timeToLive?: number;
  rawTicketExpiredAt?: Moment;
  segments: FlightSegment[];
};

export const convertFlightSliceResponseToArgs = (response: FlightSliceResponseArgs) => {
  const args: FlightSliceArgs = {
    id: response.id,
    duration: response.duration,
    deadline: response.deadline ? moment(response.deadline) : undefined,
    timeToLive: response.time_to_live ?? undefined,
    rawTicketExpiredAt: response.raw_ticket_expired_at ? moment(response.raw_ticket_expired_at) : undefined,
    segments: response.segments.map(segment => new FlightSegment(convertFlightSegmentResponseToArgs(segment)))
  };
  return args;
};

export default class FlightSlice {
  @observable id: string;
  @observable duration: string;
  @observable deadline?: Moment;
  @observable timeToLive?: number;
  @observable rawTicketExpiredAt?: Moment;
  @observable segments: FlightSegment[];

  constructor(args: FlightSliceArgs) {
    this.id = args.id;
    this.duration = args.duration;
    this.deadline = args.deadline;
    this.timeToLive = args.timeToLive;
    this.rawTicketExpiredAt = args.rawTicketExpiredAt;
    this.segments = args.segments;
  }

  @computed get startDate(): string | undefined {
    return this.segments[0]?.from?.date;
  }

  @computed get endDate(): string | undefined {
    return this.segments[this.segments.length - 1]?.to?.date;
  }
}
